import { createApp, markRaw } from 'vue';
import { createPinia } from 'pinia';
import router from '../routers/app';
import '../globals/Tailwind.css';
import ComponentsObject from '../globals/components/base/*.vue';
import BaseApp from './BaseApp.vue';
import appMixin from '../globals/Mixin';
import appDirectives from '../globals/Directives';
import setAccentColor from '../globals/utilities/SetAccentColor';
import setWindowProperties from '../globals/utilities/SetWindowProperties';
import setCustomPrototypes from '../globals/utilities/SetCustomPrototypes';
import setGlobalEventListeners from '../globals/utilities/SetGlobalEventListeners';
import vueErrorHandler from '../globals/utilities/VueErrorHandler';

if (process.env.NODE_ENV === 'development') {
	globalThis.__VUE_OPTIONS_API__ = true;
	globalThis.__VUE_PROD_DEVTOOLS__ = true;
}

const pinia = createPinia();

pinia.use(({ store }) => {
	store.$router = markRaw(router);
});

const app = createApp(BaseApp).use(pinia).use(router);

app.config.errorHandler = vueErrorHandler;

setAccentColor();
setWindowProperties();
setCustomPrototypes();

for (const value of Object.values(ComponentsObject)) {
	app.component(value.default.name, value.default);
}

app.mixin(appMixin);

Object.keys(appDirectives).forEach((name) => {
	app.directive(name, appDirectives[name]);
});

app.mount('#app');

window.VueApp = app;

setGlobalEventListeners(app);
